<template>
    <rkm-area
        v-if="cliente && cliente.ativoAppConectasusCidadao"
        title="Integrações de Aplicativos"
        type="fieldset"
    >
        <rkm-row>
            <rkm-col cols="auto">
                <rkm-form-checkbox v-model="model.integracaoAplicativo.habilitaConectasusCidadao">
                    Habilitar a funcionalidade Transporte no APP Cidadão
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="auto">
                <rkm-form-checkbox
                    :disabled="!model.integracaoAplicativo.habilitaConectasusCidadao"
                    v-model="model.integracaoAplicativo.habilitaCancelamentoAgendamentoConectasusCidadao"
                >
                    Permitir o cancelamento do agendamento de transporte
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Vuex.
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({ cliente: 'getCliente' }),
    },
    props: {
        model: { type: Object, required: true },
    },
    watch: {
        'model.integracaoAplicativo.habilitaConectasusCidadao' (habilitado) {

            if (habilitado) {

                return
            }

            this.model.integracaoAplicativo.habilitaCancelamentoAgendamentoConectasusCidadao = false
        },
    },
}
</script>